import { JsonObject, JsonProperty } from 'json2typescript';
import { Service } from '../services/service';

@JsonObject('Timesheet')
export class Timesheet {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('case_number', String, true)
    caseNum = null;

    @JsonProperty('case', Number, true)
    case: number = undefined;

    @JsonProperty('service_type', Number, true)
    serviceType: number = undefined;

    @JsonProperty('end_date', String, true)
    endDate = null;

    @JsonProperty('associated_services', [Service], true)
    services: Service[] = [];
}